import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-6 page-wrapper" data-testid="not-found-page">
      <p className="text-8xl lg:text-[10rem] text-white/10 font-bold leading-none">404</p>
      <p className="text-xl text-[#888888] lowercase mt-4 mb-8">this checkpoint doesn't exist yet.</p>
      <div className="flex gap-6">
        <Link
          to="/"
          className="border border-[#383f38] px-6 py-3 text-white lowercase hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
          data-testid="404-home-link"
        >
          go home
        </Link>
        <Link
          to="/checkpoints"
          className="px-6 py-3 text-[#888888] lowercase hover:text-white transition-all duration-300 rounded-lg"
          data-testid="404-checkpoints-link"
        >
          browse checkpoints
        </Link>
      </div>
    </div>
  );
}
